import { Box } from '@material-ui/core'
import { StatusPresenter } from 'components/domain/dashboard/StatusPresenter'
import { Redirect, useLocation } from 'react-router-dom'

export const Status = (): JSX.Element => {
  const location = useLocation()
  const queryParams = new URLSearchParams(location.search)
  const password = queryParams.get('pwd')

  if (password !== process.env.REACT_APP_BACKOFFICE_PWD) {
    return <Redirect to="/" />
  }

  return (
    <Box padding={4}>
      <StatusPresenter />
    </Box>
  )
}
